import { Col, Row } from "reactstrap";
import { Button } from "@mui/material";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

import React, { useEffect, useState } from "react";
import AppModal from "../../Common/AppModal";
import { getCustomerCards } from "../../../store/charges/action";
import { useDispatch, useSelector } from "react-redux";
import Select from "../../Common/AppSelect";
import AddCustomerCard from "../AddCustomerCard/AddCustomerCard";
import {
  confirmSubscriptionLicensesOrder,
  confirmSubscriptionLicensesOrderSuccess,
  getLicensesSubscriptionList,
} from "../../../store/manageLicense/action";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import {
  getCrmItInvoiceSingleData,
  getCrmItInvoiceSingleDataSuccess,
  getInvoiceSinglePDF,
  getInvoiceSinglePDFSuccess,
} from "../../../store/invoiceCrmIT/action";
import LoadingSpinner from "../../Common/Spinner";

export default function ConfirmNewLicenses({
  modal,
  setModal,
  toggle,
  previewLicensesSummary,
  licensesData,
  closeModal,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCustomerCards());
    return () => {
      setSubscriptionCompletedResponseData([]);
      setSubscriptionCompleted(false);
    };
  }, []);
  const { CustomerCardsList } = useSelector((state) => ({
    CustomerCardsList: state.Charges.customerCardsList?.masterpaymentcard_list,
  }));

  const confirmInitialData = {
    MasterPaymentCard_Id: "",
    Licences: [licensesData],
  };

  const [confirmData, setConfirmData] = useState(confirmInitialData);
  const [modalAddCustomerCard, setModalAddCustomerCard] = useState(false);
  const toggleAddCustomerCard = () =>
    setModalAddCustomerCard(!modalAddCustomerCard);
  const [subscriptionCompleted, setSubscriptionCompleted] = useState(false);
  const [
    subscriptionCompletedResponseData,
    setSubscriptionCompletedResponseData,
  ] = useState([]);

  const handleConfirmLicensesOrder = () => {
    dispatch(confirmSubscriptionLicensesOrder([confirmData]));
  };

  const {
    confirmSubscriptionLicensesOrderSuccessAPI,
    confirmSubscriptionLicensesOrderLoading,
  } = useSelector((state) => ({
    confirmSubscriptionLicensesOrderSuccessAPI:
      state.ManageLicense.confirmSubscriptionLicensesOrder,
    confirmSubscriptionLicensesOrderLoading:
      state.ManageLicense.confirmSubscriptionLicensesOrderLoading,
  }));

  useEffect(() => {
    if (isEmpty(confirmSubscriptionLicensesOrderSuccessAPI)) return;
    if (confirmSubscriptionLicensesOrderSuccessAPI?.status === 200) {
      toast.success(confirmSubscriptionLicensesOrderSuccessAPI?.message);
      // toggle();
      setSubscriptionCompleted(true);
      setSubscriptionCompletedResponseData(
        confirmSubscriptionLicensesOrderSuccessAPI
      );

      dispatch(getLicensesSubscriptionList());
    } else {
      toast.error(confirmSubscriptionLicensesOrderSuccessAPI?.message);
    }
    dispatch(confirmSubscriptionLicensesOrderSuccess([]));
  }, [confirmSubscriptionLicensesOrderSuccessAPI]);

  const [modalViewInvoice, setModalViewInvoice] = useState(false);
  const toggleViewInvoice = () => setModalViewInvoice(!modalViewInvoice);

  const { crmitInvoiceSinglePdfAPI } = useSelector((state) => ({
    crmitInvoiceSinglePdfAPI: state.InvoiceCrmIT.crmitInvoiceSinglePdf,
  }));

  const [getSingleInvoiceData, setGetSingleInvoiceData] = useState([]);

  useEffect(() => {
    if (isEmpty(crmitInvoiceSinglePdfAPI)) return;
    if (crmitInvoiceSinglePdfAPI?.status === 200) {
      setModalViewInvoice(true);
      setGetSingleInvoiceData(crmitInvoiceSinglePdfAPI);
    } else {
      toast.error(crmitInvoiceSinglePdfAPI?.message);
    }
    dispatch(getCrmItInvoiceSingleDataSuccess([]));
  }, [crmitInvoiceSinglePdfAPI]);
  const closeAllModals = () => {
    toggle();
    toggleViewInvoice();
    setModal(false);
  };

  useEffect(() => {
    if (isEmpty(CustomerCardsList)) return;
    const findPrimaryCard = CustomerCardsList?.filter(
      (item) => item.FlagPrimary === "1"
    );
    if (isEmpty(findPrimaryCard)) return;
    setConfirmData({
      ...confirmData,
      MasterPaymentCard_Id: findPrimaryCard[0].Id,
    });
  }, [CustomerCardsList]);
  return (
    <>
      {modalViewInvoice && (
        <AppModal
          open={modalViewInvoice}
          onClose={closeAllModals}
          title={`Invoice # ${getSingleInvoiceData?.invoice_pdf?.Id ?? ""}`}
          icon={<ReceiptLongOutlinedIcon />}
          headerAccent="indigo"
          size="md"
          footer={
            <Button color="error" variant="contained" onClick={closeAllModals}>
              close
            </Button>
          }
        >
            <div className={"single-pdf-sheet"}>
              <embed
                className={"single-pdf-sheet"}
                src={`data:application/pdf;base64,${getSingleInvoiceData?.invoice_pdf?.PdfBase64}`}
              />
            </div>
        </AppModal>
      )}
      <AppModal
        open={modal}
        onClose={toggle}
        title={
          subscriptionCompleted
            ? "Subscription Changes Completed"
            : "Licence Upgrade/Downgrade Preview"
        }
        icon={<WorkspacePremiumOutlinedIcon />}
        headerAccent="indigo"
        size="md"
        hideFooter
      >
          {subscriptionCompleted ? (
            <div>
              <h6>Subscription Completed</h6>
              <div>
                <p>{subscriptionCompletedResponseData?.message}</p>
              </div>
              <div className={"w-100 d-flex justify-content-between"}>
                <div>
                  <button
                    className={"btn btn-primary"}
                    onClick={() => {
                      dispatch(
                        getCrmItInvoiceSingleData({
                          id: subscriptionCompletedResponseData?.Invoice_Id,
                        })
                      );
                    }}
                  >
                    <span className={"me-2"}>
                      <i className="fa-solid fa-file-arrow-down"></i>
                    </span>
                    Download Invoice{" "}
                    <span>
                      {" "}
                      #{subscriptionCompletedResponseData?.Invoice_Id}
                    </span>
                  </button>
                </div>

                <div>
                  <button className={"btn btn-danger"} onClick={toggle}>
                    <span className={"me-2"}>
                      <i className="fa-solid fa-circle-xmark"></i>
                    </span>
                    Close
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <Row className="g-3">
                <Col lg={12}>
                  <table className={"w-100"}>
                    <thead>
                      <tr>
                        <th> </th>
                        <th className={"text-center"}>Current Licenses</th>

                        <th className={"text-center"}>Proposed Licenses</th>

                        <th className={"text-center"}>Change</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span className={"fw-bold"}>Active Licenses</span>
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid lightgrey",
                        }}
                      >
                        <td>
                          <span className={"ms-1"}>Monthly Licenses</span>
                        </td>
                        <td className={"text-center"}>
                          {
                            previewLicensesSummary?.current
                              ?.count_licence_monthly
                          }
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          {
                            previewLicensesSummary?.proposed
                              ?.count_licence_monthly
                          }
                        </td>
                        <td className={"text-center"}>
                          <span>
                            {Number(
                              previewLicensesSummary?.proposed
                                ?.count_licence_monthly
                            ) >
                              Number(
                                previewLicensesSummary?.current
                                  ?.count_licence_monthly
                              ) && "+"}
                            {Number(
                              previewLicensesSummary?.proposed
                                ?.count_licence_monthly
                            ) <
                            Number(
                              previewLicensesSummary?.current
                                ?.count_licence_monthly
                            )
                              ? "-"
                              : " "}
                            {
                              previewLicensesSummary?.changes
                                ?.count_licence_monthly
                            }
                          </span>
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid lightgrey " }}>
                        <td>
                          <span className={"ms-1"}>Annual Licenses</span>
                        </td>
                        <td className={"text-center"}>
                          {
                            previewLicensesSummary?.current
                              ?.count_licence_annually
                          }
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          {
                            previewLicensesSummary?.proposed
                              ?.count_licence_annually
                          }
                        </td>
                        <td className={"text-center"}>
                          {Number(
                            previewLicensesSummary?.proposed
                              ?.count_licence_annually
                          ) >
                            Number(
                              previewLicensesSummary?.current
                                ?.count_licence_annually
                            ) && "+"}
                          {Number(
                            previewLicensesSummary?.proposed
                              ?.count_licence_annually
                          ) <
                          Number(
                            previewLicensesSummary?.current
                              ?.count_licence_annually
                          )
                            ? "-"
                            : " "}
                          {
                            previewLicensesSummary?.changes
                              ?.count_licence_annually
                          }
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid lightgrey " }}>
                        <td>
                          <span className={"ms-1"}>Total</span>
                        </td>
                        <td className={"text-center"}>
                          {previewLicensesSummary?.current?.count_licence_paid}
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          {previewLicensesSummary?.proposed?.count_licence_paid}
                        </td>
                        <td className={"text-center"}>
                          {Number(
                            previewLicensesSummary?.proposed?.count_licence_paid
                          ) >
                            Number(
                              previewLicensesSummary?.current
                                ?.count_licence_paid
                            ) && "+"}
                          {Number(previewLicensesSummary?.proposed) <
                          Number(
                            previewLicensesSummary?.current?.count_licence_paid
                          )
                            ? "-"
                            : " "}
                          {previewLicensesSummary?.changes?.count_licence_paid}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <span className={"m-2 p-2"}></span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className={"fw-bold"}>Monthly Cost</span>
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid lightgrey",
                        }}
                      >
                        <td>
                          <span className={"ms-1"}>Sub Total (excl VAT)</span>
                        </td>
                        <td className={"text-center"}>
                          £
                          {
                            previewLicensesSummary?.current
                              ?.cost_licence_monthly_subtotal
                          }
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          £
                          {
                            previewLicensesSummary?.proposed
                              ?.cost_licence_monthly_subtotal
                          }
                        </td>
                        <td className={"text-center"}>
                          <span>
                            {Number(
                              previewLicensesSummary?.proposed
                                ?.cost_licence_monthly_subtotal
                            ) >
                              Number(
                                previewLicensesSummary?.current
                                  ?.cost_licence_monthly_subtotal
                              ) && "+"}
                            {Number(
                              previewLicensesSummary?.proposed
                                ?.cost_licence_monthly_subtotal
                            ) <
                            Number(
                              previewLicensesSummary?.current
                                ?.cost_licence_monthly_subtotal
                            )
                              ? "-"
                              : " "}
                            £
                            {
                              previewLicensesSummary?.changes
                                ?.cost_licence_monthly_subtotal
                            }
                          </span>
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid lightgrey " }}>
                        <td>
                          <span className={"ms-1"}>Sub Total (inc VAT)</span>
                        </td>
                        <td className={"text-center"}>
                          £
                          {
                            previewLicensesSummary?.current
                              ?.cost_licence_monthly_total
                          }
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          £
                          {
                            previewLicensesSummary?.proposed
                              ?.cost_licence_monthly_total
                          }
                        </td>
                        <td className={"text-center"}>
                          {Number(
                            previewLicensesSummary?.proposed
                              ?.cost_licence_monthly_total
                          ) >
                            Number(
                              previewLicensesSummary?.current
                                ?.cost_licence_monthly_total
                            ) && "+"}
                          {Number(
                            previewLicensesSummary?.proposed
                              ?.cost_licence_monthly_total
                          ) <
                          Number(
                            previewLicensesSummary?.current
                              ?.cost_licence_monthly_total
                          )
                            ? "-"
                            : " "}
                          £
                          {
                            previewLicensesSummary?.changes
                              ?.cost_licence_monthly_total
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <span className={"m-2 p-2"}></span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className={"fw-bold"}>Annual Cost</span>
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid lightgrey",
                        }}
                      >
                        <td>
                          <span className={"ms-1"}>Sub Total (excl VAT)</span>
                        </td>
                        <td className={"text-center"}>
                          £
                          {
                            previewLicensesSummary?.current
                              ?.cost_licence_annually_subtotal
                          }
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          £
                          {
                            previewLicensesSummary?.proposed
                              ?.cost_licence_annually_subtotal
                          }
                        </td>
                        <td className={"text-center"}>
                          <span>
                            {Number(
                              previewLicensesSummary?.proposed
                                ?.cost_licence_annually_subtotal
                            ) >
                              Number(
                                previewLicensesSummary?.current
                                  ?.cost_licence_annually_subtotal
                              ) && "+"}
                            {Number(
                              previewLicensesSummary?.proposed
                                ?.cost_licence_annually_subtotal
                            ) <
                            Number(
                              previewLicensesSummary?.current
                                ?.cost_licence_annually_subtotal
                            )
                              ? "-"
                              : " "}
                            £
                            {
                              previewLicensesSummary?.changes
                                ?.cost_licence_annually_subtotal
                            }
                          </span>
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid lightgrey " }}>
                        <td>
                          <span className={"ms-1"}>Sub Total (inc VAT)</span>
                        </td>
                        <td className={"text-center"}>
                          £
                          {
                            previewLicensesSummary?.current
                              ?.cost_licence_annually_total
                          }
                        </td>
                        <td className={"text-center"}>
                          {" "}
                          £
                          {
                            previewLicensesSummary?.proposed
                              ?.cost_licence_annually_total
                          }
                        </td>
                        <td className={"text-center"}>
                          {Number(
                            previewLicensesSummary?.proposed
                              ?.cost_licence_annually_total
                          ) >
                            Number(
                              previewLicensesSummary?.current
                                ?.cost_licence_annually_total
                            ) && "+"}
                          {Number(
                            previewLicensesSummary?.proposed
                              ?.cost_licence_annually_total
                          ) <
                          Number(
                            previewLicensesSummary?.current
                              ?.cost_licence_annually_total
                          )
                            ? "-"
                            : " "}
                          £
                          {
                            previewLicensesSummary?.changes
                              ?.cost_licence_annually_total
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <span className={"m-2 p-2"}></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row className={"mt-3"}>
                <hr />
                <Col lg={4}>
                  <span className={"fs-16 d-flex align-items-end flex-column"}>
                    Amount due today:
                  </span>
                  <div
                    // style={{ width: "200px" }}
                    className={"d-flex align-items-end flex-column"}
                  >
                    <div>
                      <span>
                        Subtotal: £{" "}
                        {previewLicensesSummary?.changes?.adhoc_amount_today_subtotal?.toFixed(
                          2
                        )}
                      </span>
                    </div>
                    <div>
                      <span>
                        VAT: £{" "}
                        {previewLicensesSummary?.changes?.adhoc_amount_today_vat?.toFixed(
                          2
                        )}
                      </span>
                    </div>
                    <div>
                      <span>
                        Total: £{" "}
                        {previewLicensesSummary?.changes?.adhoc_amount_today_total?.toFixed(
                          2
                        )}
                      </span>
                    </div>
                  </div>
                </Col>
                <Col lg={8}>
                  <div>
                    <div>
                      <span>Select Preferred card or add New one</span>
                    </div>
                    <div className={"d-flex flex-row"}>
                      <Select
                        className={"w-100 pe-2"}
                        isClearable={true}
                        value={
                          confirmData?.MasterPaymentCard_Id
                            ? {
                                value: confirmData?.MasterPaymentCard_Id,
                                label:
                                  CustomerCardsList?.find(
                                    (card) =>
                                      card?.Id ===
                                      confirmData?.MasterPaymentCard_Id
                                  )?.Brand +
                                  "Expiry " +
                                  CustomerCardsList?.find(
                                    (card) =>
                                      card?.Id ===
                                      confirmData?.MasterPaymentCard_Id
                                  )?.ExpiryMonth +
                                  " / " +
                                  CustomerCardsList?.find(
                                    (card) =>
                                      card?.Id ===
                                      confirmData?.MasterPaymentCard_Id
                                  )?.ExpiryYear +
                                  " last 4 digits ..." +
                                  CustomerCardsList?.find(
                                    (card) =>
                                      card?.Id ===
                                      confirmData?.MasterPaymentCard_Id
                                  )?.Last4Digits,
                              }
                            : []
                        }
                        options={CustomerCardsList?.map((card) => ({
                          value: card.Id,
                          label: `${card?.Brand} Expiry [${card?.ExpiryMonth} / ${card?.ExpiryYear}] last 4 digits ...${card?.Last4Digits}`,
                        }))}
                        onChange={(e) => {
                          setConfirmData({
                            ...confirmData,
                            MasterPaymentCard_Id: e?.value,
                          });
                        }}
                      ></Select>
                      <button
                        className={"btn btn-primary"}
                        style={{ width: "150px" }}
                        onClick={toggleAddCustomerCard}
                      >
                        {" "}
                        Add New Card
                      </button>
                    </div>
                  </div>
                  <div className={"mt-2"}>
                    {confirmSubscriptionLicensesOrderLoading ? (
                      <div style={{}}>
                        <LoadingSpinner
                          title={"Please wait..."}
                          extraText={
                            "Processing payment and setting up new License"
                          }
                        />
                      </div>
                    ) : (
                      <button
                        className={"btn btn-success"}
                        onClick={() => {
                          handleConfirmLicensesOrder();
                        }}
                      >
                        Confirm New Subscription
                      </button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          )}
      </AppModal>
      {modalAddCustomerCard && (
        <AddCustomerCard
          modalAddCustomerCard={modalAddCustomerCard}
          setModalAddCustomerCard={setModalAddCustomerCard}
          toggleAddCustomerCard={toggleAddCustomerCard}
        />
      )}
    </>
  );
}
